<div class="container-fluid top-nav pl-0 pr-0">
  <div class="row" style="padding-top: 2px;">
    <div class="col">
      <h6 class="page-header pt-1" style="margin-left: 15px; margin-top: 6px;">{{ 'adhoc.title' | trans }}</h6>
      <p class="page-header-sub" style="margin-left: 15px;">{{ 'adhoc.subtitle' | trans }}</p>
    </div>
    <div class="d-inline-flex">
      <button (click)="openCreate()" matTooltip="{{ 'adhoc.createtip' | trans }}" aria-label="create adhoc task"
        matTooltipPosition="left" matTooltipShowDelay="500" class="btn-empty border-0"
        style="margin-top:14px; margin-right:7px; margin-left:0px;" type="button">
        <span
          class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
          add
        </span>
      </button>
    </div>
  </div>

  <div class="card bg-secondary">
    <div *ngIf="!loading && adhocTasks.length == 0" class="row">
      <p class="mb-0 p-3 pl-4 font-weight-bold">{{ 'adhoc.notasks' | trans }}</p>
    </div>

    <div *ngFor="let task of adhocTasks" class="row border-bottom p-2 m-0 align-items-center">
      <div class="col-auto">
        <input type="checkbox" [checked]="task.taskstate === 'Done'" (change)="toggleDone(task)" />
      </div>
      <div class="col">
        <h6 class="mb-0" [class.text-strikethrough]="task.taskstate === 'Done'">{{ task.title }}</h6>
        <p class="mb-0 f-13 text-muted">
          {{ 'adhoc.responsible' | trans }}: {{ memberName(task.responsible) }}
          <span *ngIf="task.projectId"> &middot; {{ 'adhoc.project' | trans }}: {{ projectName(task.projectId) }}</span>
          <span *ngIf="task.customer"> &middot; {{ 'adhoc.customer' | trans }}: {{ customerName(task.customer) }}</span>
          <span *ngIf="task.duedate"> &middot; {{ 'adhoc.duedate' | trans }}: {{ task.duedate }}</span>
        </p>
      </div>
      <div class="col-auto">
        <button class="btn-empty border-0" type="button" (click)="openEdit(task)">
          <span class="material-icons">edit</span>
        </button>
        <button class="btn-empty border-0" type="button" (click)="deleteTask(task)">
          <span class="material-icons">delete</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop-adhoc" *ngIf="showForm">
  <div class="card bg-white p-3 adhoc-form-card">
    <h6 class="mb-3">{{ formTask.taskId ? ('adhoc.edittask' | trans) : ('adhoc.newtask' | trans) }}</h6>

    <div class="form-group">
      <label class="font-weight-light f-15 mb-0">{{ 'adhoc.tasktitle' | trans }}</label>
      <input required type="text" class="form-control" name="title" [(ngModel)]="formTask.title" />
    </div>

    <div class="form-group">
      <label class="font-weight-light f-15 mb-0">{{ 'adhoc.description' | trans }}</label>
      <textarea class="form-control" name="description" [(ngModel)]="formTask.description"></textarea>
    </div>

    <div class="form-group">
      <label class="font-weight-light f-15 mb-0">{{ 'adhoc.responsible' | trans }}</label>
      <select required class="form-control" name="responsible" [(ngModel)]="formTask.responsible">
        <option *ngIf="!formTask.responsible" [ngValue]="null" style="display:none">{{ 'adhoc.choose' | trans }}</option>
        <option *ngFor="let member of orgMembers" [ngValue]="member.personId">{{ member.membername }}</option>
      </select>
    </div>

    <div class="form-group">
      <label class="font-weight-light f-15 mb-0">{{ 'adhoc.project' | trans }} ({{ 'adhoc.optional' | trans }})</label>
      <select class="form-control" name="projectId" [(ngModel)]="formTask.projectId">
        <option [ngValue]="null">{{ 'adhoc.none' | trans }}</option>
        <option *ngFor="let project of projectList" [ngValue]="project.projectId">{{ project.title }}</option>
      </select>
    </div>

    <div class="form-group">
      <label class="font-weight-light f-15 mb-0">{{ 'adhoc.customer' | trans }} ({{ 'adhoc.optional' | trans }})</label>
      <select class="form-control" name="customer" [(ngModel)]="formTask.customer">
        <option [ngValue]="null">{{ 'adhoc.none' | trans }}</option>
        <option *ngFor="let customer of customerList" [ngValue]="customer.customerId.split('_')[0]">{{ customer.title }}</option>
      </select>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="font-weight-light f-15 mb-0">{{ 'adhoc.startdate' | trans }}</label>
          <input type="date" class="form-control" name="startdate" [(ngModel)]="formTask.startdate" />
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label class="font-weight-light f-15 mb-0">{{ 'adhoc.duedate' | trans }}</label>
          <input type="date" class="form-control" name="duedate" [(ngModel)]="formTask.duedate" />
        </div>
      </div>
    </div>

    <div *ngIf="timeregEnabled && !formTask.taskId" class="form-group">
      <label class="font-weight-light f-15 mb-0">Initial estimate (h)</label>
      <input type="number" min="0" step="0.25" class="form-control" name="taskestimate"
        [(ngModel)]="newTaskEstimateHours" placeholder="Optional">
    </div>

    <app-time-tracking-panel *ngIf="timeregEnabled && formTask.taskId"
      [taskId]="formTask.taskId"></app-time-tracking-panel>

    <div *ngIf="errorMessage != null" class="alert alert-danger">
      <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
    </div>

    <div class="row">
      <div class="col">
        <button type="button" class="btn-close" (click)="closeForm()">
          <p class="btn-save-text mb-0">{{ 'adhoc.cancel' | trans }}</p>
        </button>
      </div>
      <div class="col">
        <button type="button" class="btn-save" (click)="saveTask()">
          <p class="btn-save-text mb-0">{{ 'adhoc.save' | trans }}</p>
        </button>
      </div>
    </div>
  </div>
</div>
